(ns frontend.ux-overhaul.listing.screening.view
  (:require
   [common.localization :as loc]
   [common.opensearch.row :as os-row]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
   [frontend.ux-overhaul.listing.generic.event :as generic-event]
   [frontend.ux-overhaul.listing.generic.sub :as generic-sub]
   [frontend.ux-overhaul.listing.screening.event :as screening-event]
   [frontend.ux-overhaul.listing.screening.sub :as screening-sub]
   [frontend.ux-overhaul.listing.generic.view :as listing]
   [frontend.view.grid.screening.events :as screening-grid-events]
   [frontend.view.grid.screening.subs :as screening-grid-subs]
   [frontend.view.grid.screening.view :as screening-grid-view]
   [frontend.view.modals.bulk-edit-entity.view :as bulk-edit-modal]
   [frontend.view.not-found :as not-found]
   [ui.view.kanban-opensearch.event :as kanban-event]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def listing-id "screening-listing")

(defn- open-screening-profile!
  [value]
  (js/console.log "Open " value)
  (if-let [profile-id (os-row/entity-id value)]
    (rf/dispatch [::screening-grid-events/open-modal profile-id])
    (js/console.log "Cannot open screening profile : " value)))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id             listing-id
         :initial-view-mode      :kanban
         :entity-type            :entity.type/screening-profile
         :pipeline-id            nil
         :filters                {:enabled? true
                                  :view-id :screening
                                  :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes   #{:kanban :grid :gallery :list}
         ;; Each :event has to carry its own {:listing-id ...}: the listing
         ;; dispatches a vector :event verbatim and appends nothing, so a
         ;; handler destructuring :listing-id from the event args otherwise gets
         ;; nil. bulk-delete-selected did, which made it resolve an empty
         ;; selection and silently do nothing.
         :toolbar-actions        [{:id                  :bulk-edit-screening-profiles
                                   :label               (loc/tr :bulk-edit)
                                   :visible?            true
                                   :enabled?            true
                                   :requires-selection? true
                                   :event               [::screening-event/open-bulk-edit {:listing-id listing-id}]}
                                  {:id                  :bulk-delete-screening-profiles
                                   :label               (loc/tr :confirm-delete-selected-button)
                                   :visible?            true
                                   :enabled?            true
                                   :requires-selection? true
                                   :event               [::screening-event/bulk-delete-selected {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      (let [bulk-edit-open? @(rf/subscribe [::screening-sub/bulk-edit-open?])
            selected-profile-id @(rf/subscribe [::screening-grid-subs/selected-screening-profile])
            selected-ids @(rf/subscribe [::generic-sub/selected-ids listing-id])
            context @(rf/subscribe [::generic-sub/context listing-id])
            accessible-field-paths (->> (or (:accessible-fields context) [])
                                        (keep :field-path)
                                        vec)
            setup-state (r/atom {:selected             (->> selected-ids
                                                            (map (fn [id] [id true]))
                                                            (into {}))
                                 :sorted-grid-entities (->> selected-ids
                                                            (mapv (fn [id]
                                                                    {:db/id id})))})
            setup-args {:state       setup-state
                        :column-keys (fn [] accessible-field-paths)
                        :mandatory?  (fn [_] false)}]
        [:<>
         [listing/view
          {:listing-id               listing-id
           :title                    (loc/tr :screening-profiles)
           :breadcrumbs              [(loc/tr :screening) (loc/tr :screening-profiles)]
           :show-view-mode-selector? true
           :query-placeholder        (loc/tr :listing.screening/search-placeholder)
           :on-row-clicked           open-screening-profile!
           :on-card-clicked          open-screening-profile!}]
         (when selected-profile-id
           [screening-grid-view/new-modal
            {:hide!    #(rf/dispatch [::screening-grid-events/close-modal])
             :selected selected-profile-id}])
         (when bulk-edit-open?
           [bulk-edit-modal/view
            {:setup-args   setup-args
             :entity-type  :entity.type/screening-profile
             :on-save-success #(rf/dispatch [::kanban-event/reload-visible-columns
                                             {:kanban-id (str listing-id "-kanban")}])
             :close-modal! #(rf/dispatch [::screening-event/close-bulk-edit
                                          {:listing-id listing-id}])}])]))}))

(defmethod routing/render-view :screening
  [_]
  (if (or (session/is-read-only-user?)
          (not (session/screening?)))
    [not-found/not-found-view]
    [default-page-layout/view
     [page-content]]))
